import React, {forwardRef} from 'react';
import classNames from 'classnames';

import {CaretDown} from '../SvgIcon/CaretDown';

interface ButtonDropdownProps {
  label: string;
  selectedOutput: string;
  className?: string;
  disabled?: boolean;
  isOpen?: boolean;
  onClick?: () => void;
}

export const ButtonDropdown = forwardRef<
  HTMLButtonElement,
  ButtonDropdownProps
>(
  (
    {
      label,
      selectedOutput,
      className,
      disabled,
      onClick,
      isOpen,
    }: ButtonDropdownProps,
    ref,
  ) => {
    return (
      <button
        ref={ref}
        onClick={onClick}
        disabled={disabled}
        className={classNames(
          'cursor-pointer flex items-center justify-between border border-gray-400 rounded-2xl p-2 md:p-3 w-full',
          className,
        )}
      >
        <div>
          <p className="text-xs md:text-sm font-light text-gray-500 text-left">
            {label}
          </p>
          <p
            className="text-sm md:text-md text-gray-900 mt-1 text-left"
            data-testid="combo-output-label"
          >
            {selectedOutput}
          </p>
        </div>
        <div>
          <CaretDown
            classes={classNames({
              'rotate-180': isOpen,
            })}
          />
        </div>
      </button>
    );
  },
);
